(function () {
  'use strict';

  const STICKY_SEL = '.nh-pdp-sticky-atc';
  const ATC_FORM_SEL = 'form[action*="/cart/add"]';
  const ATC_BTN_SEL = ATC_FORM_SEL + ' .add-to-cart, ' + ATC_FORM_SEL + ' button[data-add-to-cart]';

  let stickyEl = null;
  let stickyBtn = null;
  let mainATC = null;
  let resizeHandler = null;

  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function isATCDisabled(btn) {
    if (!btn) return true;
    return btn.disabled || btn.classList.contains('btn--loading');
  }

  function showSticky() {
    if (!stickyEl) return;
    stickyEl.classList.add('nh-pdp-sticky-atc--visible');
    stickyEl.setAttribute('aria-hidden', 'false');
  }

  function syncStickyState() {
    if (!stickyBtn || !mainATC) return;
    stickyBtn.disabled = isATCDisabled(mainATC);
    if (stickyEl && stickyEl.dataset.nhStickyAtcCustomText) return;
    const mainText = mainATC.querySelector('[data-add-to-cart-text]');
    const stickyText = stickyBtn.querySelector('[data-nh-sticky-atc-text]');
    if (mainText && stickyText && mainText.textContent) {
      stickyText.textContent = mainText.textContent.trim();
    }
  }

  function handleStickyClick(e) {
    e.preventDefault();
    if (mainATC && !isATCDisabled(mainATC)) {
      mainATC.click();
    }
  }

  function setupListeners() {
    if (resizeHandler) return;
    resizeHandler = debounce(syncStickyState, 100);
    window.addEventListener('resize', resizeHandler);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', handleStickyClick);
    }
  }

  function pollATC(cb) {
    const attempt = () => {
      const btn = document.querySelector(ATC_BTN_SEL);
      if (btn) {
        cb(btn);
        return true;
      }
      return false;
    };
    if (attempt()) return;
    let tries = 0;
    const id = setInterval(() => {
      tries++;
      if (attempt() || tries > 50) clearInterval(id);
    }, 100);
  }

  function init() {
    stickyEl = document.querySelector(STICKY_SEL);
    if (!stickyEl) return;
    stickyBtn = stickyEl.querySelector('[data-nh-sticky-atc-trigger]');
    if (!stickyBtn) return;

    showSticky();

    pollATC(function (btn) {
      mainATC = btn;
      setupListeners();
      syncStickyState();

      const form = btn.closest('form');
      if (form) {
        new MutationObserver(syncStickyState).observe(form, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'disabled']
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
